import React from 'react'

export const ArrowRight = () => <path d='M17.6,12c0,0.3-0.1,0.6-0.3,0.8l-8.9,8.9c-0.4,0.4-1.1,0.4-1.6,0c-0.4-0.4-0.4-1.1,0-1.6l8.1-8.1L6.8,3.9c-0.4-0.4-0.4-1.1,0-1.6c0.4-0.4,1.1-0.4,1.6,0l8.9,8.9C17.4,11.4,17.6,11.7,17.6,12z' />
